/*
 * crioh-reviews-visibility.js
 * La fila "Valoraciones" del acordeón de la ficha no lleva contenido propio:
 * lleva un <etrusted-widget> que rellena el JS de Trusted Shops. Liquid no
 * puede saber si el producto tiene reseñas, así que la fila salía siempre y en
 * la mayoría de productos quedaba una cabecera que abre sobre el vacío.
 *
 * Trusted Shops renderiza en shadow DOM CERRADO: `shadowRoot` es null y el
 * innerHTML se queda a 0 caracteres incluso con reseñas. Lo único observable es
 * el TAMAÑO: sin reseñas el widget se queda en 0x0; con reseñas mide cientos de
 * píxeles (comprobado: 0x0 sin, 656x477 / 656x648 / 656x615 con).
 *
 * OJO con el estado de espera: el widget es lazy y no empieza a pintar si está
 * recortado o colapsado, así que la fila NO puede esperar con display:none ni
 * con height:0 + overflow:hidden — se quedaría a 0 px para siempre y no se
 * revelaría nunca. Por eso el CSS del bloque la saca de flujo conservando el
 * ancho, que es el único estado en el que pinta sin ocupar sitio.
 *
 * Reparto de responsabilidades:
 *   - blocks/_accordion-row.liquid marca la fila con data-crioh-reviews="pending"
 *     y su CSS la saca de flujo desde el primer paint (sin parpadeo).
 *   - este script la pasa a "ready" en cuanto el widget mide algo, o a "empty"
 *     si a los SETTLE_MS sigue vacía (y entonces ya sí se puede display:none,
 *     que la saca también del árbol de accesibilidad).
 *   - de paso, cuando hay reseñas hace que la valoración de arriba baje hasta
 *     aquí al pulsarla.
 */
(function () {
  if (window.__criohReviewsVisibility) return;
  window.__criohReviewsVisibility = true;

  /* Margen para que Trusted Shops pinte; en la tienda tarda 1,3-1,8 s, así que
     8 s da aire de sobra. Si se agota, la fila se descarta: cuando su JS no
     llega (adblock, consentimiento sin aceptar) tampoco hay reseñas que mostrar,
     así que ocultar es el resultado correcto. */
  var SETTLE_MS = 8000;
  var POLL_MS = 250;
  var OPEN_ANIMATION_FALLBACK_MS = 400;

  function hasSize(el) {
    return el.getBoundingClientRect().height > 0;
  }

  /* La valoración de la cabecera. Primero por el envoltorio #ratings que trae el
     custom_liquid de la plantilla; si no está, por estructura: es el único
     <etrusted-widget> que NO cuelga de un <details>. Nunca por
     data-etrusted-widget-id, que vive en la plantilla (editable desde el admin)
     y no debe quedar hardcodeado en el tema. */
  function findRatingWidget() {
    var wrapper = document.getElementById('ratings');
    if (wrapper) {
      var inner = wrapper.querySelector('etrusted-widget');
      if (inner) return inner;
    }

    var widgets = document.querySelectorAll('etrusted-widget');
    for (var i = 0; i < widgets.length; i++) {
      if (!widgets[i].closest('details')) return widgets[i];
    }
    return null;
  }

  /* El header es fixed y taparía la fila al bajar. Se mide en el momento del
     click y no por CSS porque ninguna de las variables de altura del tema
     (--header-height, --header-group-height) está poblada en :root: dan cadena
     vacía, así que un calc() con ellas se queda en el gap y la fila acaba
     debajo del header. Medido en la tienda: 144 px, igual arriba que con scroll. */
  function stickyHeaderOffset() {
    var header = document.getElementById('ch-sticky-hdr');
    if (!header) return 0;
    return header.getBoundingClientRect().height;
  }

  function applyScrollMargin(el) {
    if (el) el.style.scrollMarginTop = stickyHeaderOffset() + 16 + 'px';
  }

  /* Abre la fila y baja hasta ella desde JS. Solo se usa cuando la plantilla NO
     envuelve la valoración en un ancla; con ancla baja el navegador, que es más
     fiable. El acordeón anima el despliegue, así que se espera al final de la
     transición, con fallback por tiempo si no llega transitionend. */
  function openAndScroll(row) {
    var details = row.querySelector('details');
    if (!details) return;

    applyScrollMargin(row);

    if (details.open) {
      row.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    var content = details.querySelector('.details-content');
    var scrolled = false;
    var scrollToRow = function () {
      if (scrolled) return;
      scrolled = true;
      row.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    if (content) content.addEventListener('transitionend', scrollToRow, { once: true });
    setTimeout(scrollToRow, OPEN_ANIMATION_FALLBACK_MS);

    details.open = true;
  }

  /* Con la valoración envuelta en <a href="#opiniones"> (lo pone el custom_liquid
     de la plantilla) el scroll lo hace el navegador: aquí solo se abre la fila,
     SIN preventDefault, y se prepara el scroll-margin del destino para que no
     quede debajo del header. El destino está dentro del <details>, así que se
     abre antes de que el navegador procese el salto al ancla. */
  function openForAnchor(row, anchor) {
    var details = row.querySelector('details');
    if (details && !details.open) details.open = true;

    applyScrollMargin(row);

    var hash = anchor.hash || '';
    if (hash.length > 1) applyScrollMargin(document.getElementById(hash.slice(1)));
  }

  function wireRatingWidget(row) {
    var rating = findRatingWidget();
    if (!rating) return;

    var anchor = rating.closest('a[href^="#"]');
    var target = anchor || rating;
    if (target.getAttribute('data-crioh-reviews-link')) return;
    target.setAttribute('data-crioh-reviews-link', '');

    if (anchor) {
      target.addEventListener('click', function () {
        openForAnchor(row, anchor);
      });
      return;
    }

    /* Sin ancla hay que fabricar la semántica de botón a mano. */
    target.setAttribute('role', 'button');
    target.setAttribute('tabindex', '0');
    target.style.cursor = 'pointer';

    target.addEventListener('click', function (event) {
      event.preventDefault();
      openAndScroll(row);
    });

    target.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        openAndScroll(row);
      }
    });
  }

  function reveal(row) {
    row.setAttribute('data-crioh-reviews', 'ready');
    wireRatingWidget(row);
  }

  function discard(row) {
    row.setAttribute('data-crioh-reviews', 'empty');
  }

  function watch(row) {
    var widget = row.querySelector('etrusted-widget');
    /* Sin widget no hay nada que medir ni que mostrar. */
    if (!widget) {
      discard(row);
      return;
    }

    if (hasSize(widget)) {
      reveal(row);
      return;
    }

    /* Se sondea en vez de usar ResizeObserver: el widget es un custom element
       sin display propio, o sea `display: inline`, y la especificación de
       ResizeObserver excluye los inline no reemplazados. Comprobado en la
       tienda: 0 callbacks en 10 s con el widget ya pintado a 615 px, mientras
       el sondeo lo detecta a ~2 s. Son unas 30 medidas de un solo elemento en
       el peor caso, así que el coste es irrelevante. */
    var started = Date.now();
    var poll = setInterval(function () {
      if (hasSize(widget)) {
        clearInterval(poll);
        reveal(row);
      } else if (Date.now() - started > SETTLE_MS) {
        clearInterval(poll);
        discard(row);
      }
    }, POLL_MS);
  }

  function init() {
    var rows = document.querySelectorAll('accordion-custom[data-crioh-reviews="pending"]');
    for (var i = 0; i < rows.length; i++) watch(rows[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
